import { useState } from 'react';
import SubmitButton from '../SubmitButton/SubmitButton';
import BrandForm from './BrandForm/BrandForm';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

BrandsCreateButton.propTypes = {
  update: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export default function BrandsCreateButton({ update, isLoading }) {
  const [isOpenForm, setIsOpenForm] = useState();
  const { t } = useTranslation();

  return (
    <>
      <SubmitButton
        isLoading={isLoading}
        onClick={() => setIsOpenForm(true)}
        txt={t('create a brand')}
      />
      {isOpenForm && (
        <BrandForm
          update={update}
          setClose={() => setIsOpenForm(false)}
        />
      )}
    </>
  );
}
